import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { normalizePremiumFolderData } from '../../../../utils/normalizePremiumFolderData';
import Premium from '@wix/da-ds/pkg/Icons/24x24/Premium';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import EyeDisc2 from '@wix/da-ds/pkg/Icons/24x24/EyeDisc2';
import Points from '@wix/da-ds/pkg/Icons/Points';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiContextProvidedValue, BiData, } from '@wix/da-bi/pkg/events';
import { getDeviationResourceType } from '../../../_helpers';
import Button, { ProfileOwnerWatchButton } from '../../../../Button';
import { Url } from '@wix/da-url';
import s from './PremiumCover.scss';
export var PremiumCover = function (_a) {
    var _b;
    var premiumFolderData = _a.deviation.premiumFolderData, deviation = _a.deviation;
    var t = useTranslation().t;
    var _c = normalizePremiumFolderData(premiumFolderData), isPremiumLocked = _c.isPremiumLocked, isPaidFolder = _c.isPaidFolder, isWatchToAccess = _c.isWatchToAccess, folderId = _c.folderId, folderUrl = _c.folderUrl, formattedDollarPrice = _c.formattedDollarPrice, pointPrice = _c.pointPrice, subproductId = _c.subproductId;
    if (!isPremiumLocked) {
        return null;
    }
    return (React.createElement("div", { className: s['paywall-wrapper'] },
        React.createElement("div", { className: s['paywall-cover'] },
            isPaidFolder && (React.createElement(React.Fragment, null,
                React.createElement(Premium, { className: s['paywall-icon'], size: IconSize.BIG }),
                React.createElement("div", { className: s['paywall-title'] }, t('deviation.paywall.premiumFolders.title')),
                React.createElement("div", { className: s['cta-text'] },
                    React.createElement(Trans, { i18nKey: "deviation.paywall.premiumFolders.text" },
                        'To view, unlock its ',
                        React.createElement(BiLink, { className: s['folder-preview-button'], href: folderUrl }, "Premium Deviation"),
                        ' — and support the artist!')),
                React.createElement("div", null,
                    React.createElement(Button, { view: "b18", height: "medium", href: subproductId ? Url.checkoutLink(subproductId) : undefined, biData: BiData({
                            evid: 361,
                            typeid: getDeviationResourceType(deviation),
                            itemid: deviation.deviationId,
                            authorid: (_b = deviation.author) === null || _b === void 0 ? void 0 : _b.useridUuid,
                            galleryid: folderId !== null && folderId !== void 0 ? folderId : 0,
                            points: pointPrice,
                            rank: BiContextProvidedValue,
                            reason_shown: BiContextProvidedValue,
                            section_typeid: BiContextProvidedValue,
                            sectionid: BiContextProvidedValue,
                            sectionname: BiContextProvidedValue,
                            sectionrank: BiContextProvidedValue,
                            sectiontype: BiContextProvidedValue,
                            sort_type: BiContextProvidedValue,
                            widgetname: BiContextProvidedValue,
                        }) }, "Unlock for ".concat(formattedDollarPrice, " / "),
                        React.createElement(Points, { className: s['points-icon'], size: IconSize.TINY, disableDefaultColors: true }), "".concat(pointPrice))))),
            isWatchToAccess && (React.createElement(React.Fragment, null,
                React.createElement(EyeDisc2, { className: s['paywall-icon'], size: IconSize.BIG }),
                React.createElement("div", { className: s['paywall-title'] }, t('deviation.paywall.watchersOnly.title')),
                React.createElement("div", { className: s['cta-text'] }, t('deviation.paywall.watchersOnly.text')),
                deviation.author && (React.createElement(ProfileOwnerWatchButton, { className: s['watch-button'], user: deviation.author, onToggleWatchSuccess: function () {
                        window.location.href = deviation.url;
                    } })))))));
};
PremiumCover.displayName = 'PremiumCover';
export default PremiumCover;
//# sourceMappingURL=PremiumCover.js.map